import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';

import config from 'config';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import LoginCard from 'components/Cards/LoginCard';
import CustomInput from 'components/CustomInput/CustomInput';
import CustomPasswordInput from 'components/CustomInput/CustomPasswordInput';
import Button from 'components/CustomButtons/Button';
import SweetAlert from 'components/SweetModal/SweetAlert';
import Sep from 'components/Miscellaneous/Sep';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import FormHOC from 'hoc/FormHOC';

//helpers
import { Context } from 'context/Context';

import loginPageStyle from 'views/Auth/style/loginPageStyle';

class LoginPage extends Component {
  state = {
    // forbiddenAlert : warningAlert / noAccountAlert : snackbar
    forbiddenAlert: null,
    noAccountAlert: null,
  };

  // log in user if inputs are good
  logIn = (e, response, provider) => {
    if (e) e.preventDefault();

    if (response && response.error === 'popup_closed_by_user') {
      return false;
    }
    // if not social provider (facebook/google), first check if email and password are valid
    if (!provider && !this.props.handleOnSubmit(['email', 'password'])) {
      return null;
    }

    const providerUrl = provider ? `_${provider}` : '';

    axios
      .post(`${config.API_URL}/public/auth/log_in${providerUrl}`, {
        access_token: response && response.accessToken,
        email: this.props.email,
        password: this.props.password,
      })
      .then(async (res) => {
        this.props.context.updateUser(res.data.user);
        localStorage.setItem('token', JSON.stringify(res.data.user.token));

        // redirect user on /bienvenu if not active
        let redirectUrl = res.data.user.account.is_active ? '/' : '/auth/bienvenue';

        // make pro user sign a chart if not already signed
        if (
          res.data.user.account.is_active &&
          res.data.user.account.type === 'pro' &&
          !res.data.user.account.has_signed_charter
        ) {
          redirectUrl = '/charte';
        }

        // redirect hired student to /candidatures endpoint
        if (res.data.user.account.type === 'student') {
          await axios
            .get(`${config.API_URL}/api/applications/student/${res.data.user._id}`, {
              headers: {
                Authorization: `Bearer ${res.data.user.token}`,
              },
            })
            .then((apps) => {
              apps.data.map((app) => {
                return app.status === 'hiring' ? (redirectUrl = '/candidatures') : '';
              });
            });
        }

        return this.props.history.push(redirectUrl);
      })
      .catch(() => {
        this.showAlert('forbiddenAlert');
      });
  };

  showAlert = (nameAlert) => {
    this.setState({ [nameAlert]: true });
  };

  hideAlert = (nameAlert) => {
    this.setState({ [nameAlert]: null });
  };

  render() {
    const { classes, emailState, passwordState, handleOnChange } = this.props;

    const forbiddenAlert = this.state.forbiddenAlert && (
      <SweetAlert
        danger
        title='Accès interdit !'
        onConfirm={() => this.hideAlert('forbiddenAlert')}
        confirmBtnText='Ok'
        text='Problème de connexion. Vérifiez votre email et votre mot de passe.'
      />
    );
    const noAccountAlert = this.state.noAccountAlert && (
      <SweetAlert
        danger
        title='Pas encore de compte ?'
        onConfirm={() => this.hideAlert('noAccountAlert')}
        confirmBtnText='Ok'
        text="Nous n'avons pas pu trouver votre compte. Rendez-vous sur la page d'inscription pour en créer un."
      />
    );

    const footer = (
      <GridContainer alignItems='center' justifyContent='space-between'>
        <ItemGrid noPadding={true}>Pas encore de compte ?</ItemGrid>
        <ItemGrid noPadding={true}>
          <Button
            color='lightGray'
            customClass={classes.buttonFooter}
            onClick={() =>
              this.props.history.push({
                pathname: '/auth/inscription',
              })
            }>
            S'inscrire
          </Button>
        </ItemGrid>
      </GridContainer>
    );

    const socials = (
      <Fragment>
        <FacebookLogin
          appId={config.FACEBOOK_ID}
          fields='name, first_name, last_name, email' //picture
          callback={(response) => this.logIn(null, response, 'facebook')}
          scope='public_profile,email'
          render={(renderProps) => (
            <Button
              color='facebook'
              fullWidth
              noBorder
              customClass={`${classes.socialButton} ${classes.facebook}`}
              onClick={renderProps.onClick}>
              <i className={`${classes.socialButtonIcons} ${classes.marginRight10} fab fa-facebook-f`} /> Se connecter
              avec facebook
            </Button>
          )}
        />

        <GoogleLogin
          clientId={config.GOOGLE_ID}
          onSuccess={(response) => {
            this.logIn(null, response, 'google');
          }}
          onFailure={(response) => {
            this.logIn(null, response, 'google');
          }}
          render={(renderProps) => (
            <Button
              color='google'
              fullWidth
              noBorder
              customClass={`${classes.socialButton} ${classes.google}`}
              onClick={renderProps.onClick}>
              <i className={`${classes.socialButtonIcons} ${classes.marginRight10} fab fa-google`} /> Se connecter avec
              Google
            </Button>
          )}
        />
      </Fragment>
    );

    const content = (
      <Fragment>
        <CustomInput
          success={emailState === 'success'}
          error={emailState === 'error'}
          labelText='Email *'
          id='email'
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            type: 'email',
            placeholder: 'prenom.nom@mail.com',
            onChange: (event) => handleOnChange(event.target.value, 'email', 'email'),
          }}
        />
        <CustomPasswordInput
          success={passwordState === 'success'}
          error={passwordState === 'error'}
          labelText={
            <GridContainer alignItems='center' justifyContent='space-between' spacing={0}>
              <ItemGrid noPadding={true}>Mot de passe *</ItemGrid>
              <ItemGrid noPadding={true}>
                <Button
                  tabIndex={-1}
                  color='primaryNoBackground'
                  customClass={classes.buttonFlat}
                  onClick={() =>
                    this.props.history.push({
                      pathname: '/auth/mot-de-passe',
                    })
                  }>
                  Mot de passe oublié ?
                </Button>
              </ItemGrid>
            </GridContainer>
          }
          id='password'
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            placeholder: 'Mot de passe',
            onChange: (event) => handleOnChange(event.target.value, 'password', 'password'),
          }}
        />
        <Button color='primary' fullWidth={true} type='submit'>
          Se Connecter
        </Button>
      </Fragment>
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {forbiddenAlert}
          {noAccountAlert}
          <GridContainer justifyContent='center'>
            <ItemGrid xs='auto'>
              <form onSubmit={(e) => this.logIn(e)}>
                <LoginCard
                  customCardClass={classes.card}
                  headerColor='white'
                  cardTitle='Se connecter'
                  cardSubtitle={<Sep text='Ou' />}
                  socials={socials}
                  content={content}
                  footer={footer}
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  email: PropTypes.string,
  emailState: PropTypes.string,
  password: PropTypes.string,
  passwordState: PropTypes.string,
};

const WrappedComponent = FormHOC(LoginPage);

export default withStyles(loginPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
